// A MIDI lane's instrument, as the seed stores it (2026-10-09): one of the
// browser synth's presets (web-shared/src/lib/synth.ts PRESETS), named by id.
// It is the room's own field, not a device — Live's device chain is the Set's,
// and the extension's poller would overwrite a device the room invented.
// Absent ⇒ "sine", which every lane played before the field existed.

export const INSTRUMENT_IDS = ["sine", "keys", "pluck", "bass", "pad", "lead", "kit"] as const;

export type InstrumentId = (typeof INSTRUMENT_IDS)[number];

export function isInstrumentId(value: unknown): value is InstrumentId {
  return typeof value === "string" && (INSTRUMENT_IDS as readonly string[]).includes(value);
}
